import { render, staticRenderFns } from "./ChaiEventPage.vue?vue&type=template&id=4ada76e8"
import script from "./ChaiEventPage.vue?vue&type=script&lang=js"
export * from "./ChaiEventPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports